import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this);
    document.addEventListener("click", this.closeOnClickOutside);
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside);
  }

  toggle(e) {
    e.preventDefault();
    this.menuTarget.classList.toggle("hidden");
  }

  closeOnClickOutside(e) {
    if (!this.element.contains(e.target)) {
      this.menuTarget.classList.add("hidden");
    }
  }
}
